import React, { useEffect, useState } from "react";
import { Crown, Lock, Flame, CheckCircle2, ExternalLink } from "lucide-react";
import api from "@/lib/api";

export default function Patreon() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  const url = stats?.patreon_url || "https://patreon.com/c/SavageUncensored";
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="patreon-page">
      <div className="text-center mb-12">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF9F0A] font-bold">Support</span>
        <h1 className="font-display text-5xl sm:text-6xl font-black mt-3 tracking-tighter">Get it first on <span className="text-[#E50914]">Patreon</span></h1>
        <p className="text-zinc-400 mt-4 max-w-2xl mx-auto">
          Patreon supporters get every uncensored release the moment it drops — before the community goal even starts.
          Your support is what funds the entire studio.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
        {[
          { icon: Crown, color: "#E50914", title: "Day-1 Uncensored", desc: "Every uncensored release lands in your feed instantly." },
          { icon: Lock, color: "#FF9F0A", title: "Exclusive Vault", desc: "Patreon-only releases that never go public." },
          { icon: CheckCircle2, color: "#32D74B", title: "Power the goal", desc: "Your support drops the like goals lower for everyone." },
        ].map((p, i) => (
          <div key={i} className="glass rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: `${p.color}1a`, color: p.color, border: `1px solid ${p.color}44` }}>
              <p.icon className="w-5 h-5" />
            </div>
            <h3 className="font-display font-bold text-lg mb-1">{p.title}</h3>
            <p className="text-sm text-zinc-400">{p.desc}</p>
          </div>
        ))}
      </div>

      <div className="glass-strong rounded-3xl p-10 text-center relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#E50914]/20 blur-3xl" />
        <Flame className="w-10 h-10 mx-auto text-[#FF9F0A]" />
        <h2 className="font-display text-3xl sm:text-4xl font-black mt-4 mb-3">Ready to go uncensored?</h2>
        <p className="text-zinc-400 max-w-lg mx-auto mb-6">Join SavageUncensored on Patreon and get instant access to every uncensored release.</p>
        <a
          data-testid="patreon-cta"
          href={url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-[#E50914] hover:bg-[#F6121D] text-white font-bold text-lg shadow-[0_0_40px_rgba(229,9,20,0.5)] transition-colors"
        >
          <Crown className="w-5 h-5 text-[#FF9F0A]" /> Become a Supporter <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
